import {procurementExpectedUser} from './procurementOperationalContext.js';
const id=value=>/^[1-9][0-9]*$/.test(String(value??''))&&Number.isSafeInteger(Number(value))&&Number(value)<=2147483647;
function invalid(){throw new Error('Invoice access could not be verified. Refresh the review page.');}
export async function readInvoiceReview(client,invoiceId,user,{signal}={}){
  if(!id(invoiceId)||!id(user?.id))invalid();
  const expected=procurementExpectedUser(user,user.is_platform_admin===true?(await client.get('/admin/context',{signal})).data:null);
  const {data}=await client.get(`/invoice/review/hub/${invoiceId}`,{signal});
  const scope=data?.response_scope,access=data?.review_access;
  if(!scope||String(scope.company_id)!==String(expected.company_id)||String(scope.unit_id)!==String(expected.unit_id)||
    String(scope.user_id)!==String(user.id)||String(scope.invoice_id)!==String(invoiceId)||String(data.invoice_id)!==String(invoiceId)||
    !access||typeof access.can_update_status!=='boolean'||typeof access.can_add_note!=='boolean'||access.can_relink!==false)invalid();
  return data;
}
export function canUpdateInvoiceReview(hub,invoiceId,user){
  const scope=hub?.response_scope;
  return !!scope&&String(scope.invoice_id)===String(invoiceId)&&String(scope.user_id)===String(user?.id)&&
    (user?.is_platform_admin===true||String(scope.company_id)===String(user?.company_id)&&String(scope.unit_id)===String(user?.unit_id))&&
    hub.review_access?.can_update_status===true;
}
export async function updateInvoiceReview(client,hub,invoiceId,user,status){
  if(!canUpdateInvoiceReview(hub,invoiceId,user))throw new Error('Invoice review changes require approval permission.');
  if(!['matched','reviewed','review_required'].includes(status))throw new Error('Use the invoice approval workflow for financial decisions.');
  const {data}=await client.post(`/invoice/review/${invoiceId}/status`,{status});
  if(data?.ok!==true||String(data.invoice_id)!==String(invoiceId)||data.status!==status)invalid();
  return data;
}
export function normalizeInvoiceHistory(data){
  const rows=Array.isArray(data)?data:[data?.items,data?.rows,data?.invoices,data?.history,data?.data].find(Array.isArray);
  if(!rows)throw new Error('Invoice history could not be verified.');
  return rows.filter(Boolean);
}
